import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M194-88q-67.28 0-95.64-60T112-260l222-268v-236h-32q-22.1 0-37.05-16Q250-796 250-818.07t14.95-37Q279.9-870 302-870h356q22 0 38 14.95T712-818q0 22.95-15.53 38.47Q680.95-764 658-764h-30v236l220 268q42 52 13 112t-95 60H194Zm0-106h572L522-492v-272h-82v272L194-194Zm286-285Z" }, null, -1)
  ]))]))
}
export default { render: render }